<div id="notfound">
    <div class="notfound-404">
        <h1>404</h1>
        <h2>Page not found</h2>
        <p>we are sorry, the page you requested could not be found please go back to the <a href="/">Homepage</a>
        </p>
    </div>
</div>